__turbopack_context__.v({
  "hubspotScriptButton": "HubspotScript-module__dQI90a__hubspotScriptButton",
  "hubspotScriptButtonOpen": "HubspotScript-module__dQI90a__hubspotScriptButtonOpen",
});
